<template>
  <div class="cf-card cf-card--clickable cf-flex cf-clear-padding">
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-center cf-flex--gap-12 cf-flex--no-shrink cf-padding cf-border-right cf-max-width-175">
      <img
        v-if="orderDetailsContent.imageUrl"
        :src="orderDetailsContent.imageUrl"
        :alt="orderDetailsContent.name"
        class="cf-order-mode-image"
      >
      <span
        v-else
        :class="`cf-icon primary far ${ orderDetailsContent.icon }`"
      />

      <div class="cf-flex cf-flex--column">
        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          {{ orderDetailsContent.name }}
        </p>

        <p
          v-if="displayRoomNumber"
          class="cf-subtitle cf-subtitle--3"
        >
          {{ tableNumberDisplay }}
        </p>
      </div>
    </div>

    <div class="cf-grid cf-grid--2-grid-column-left-large cf-full-width cf-padding-12">
      <div
        v-if="['delivery', 'shipping'].includes(orderDetails.fulfillmentType)"
        class="cf-flex cf-flex--column cf-flex--align-start cf-flex--justify-center cf-max-width-175"
      >
        <p
          v-if="orderDetails.deliveryAddress.type"
          class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy"
        >
          {{ orderDetails.deliveryAddress.type }}
        </p>

        <p class="cf-subtitle cf-subtitle--2 cf-no-wrap-ellipsis">
          {{ deliveryAddress }}
        </p>
      </div>

      <div
        v-else
        class="cf-flex cf-flex--column cf-flex--align-start cf-flex--justify-center cf-max-width-175"
      >
        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          {{ selectedLocation.description }}
        </p>

        <p class="cf-subtitle cf-subtitle--2 cf-no-wrap-ellipsis">
          {{ locationAddress }}
          <template v-if="selectedLocation.address.landmarkOrCrossStreet">
            ({{ selectedLocation.address.landmarkOrCrossStreet }})
          </template>
        </p>
      </div>

      <div
        v-if="orderDetails.fulfillmentType !== 'room-service'"
        class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-end"
      >
        <button
          v-if="orderDetails.orderType !== 'group'"
          class="cf-button cf-button--tertiary cf-button--xs"
          type="button"
          title="Change Location"
          @click="editOrderDetailsClickHandler"
        >
          Edit
        </button>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import { formatAddressInline } from '@/helpers/address-format';


  export default {
    name: 'CfSelectedLocationOrderDetails',

    props: {
      headerTitle: {
        type: String,
        default: ''
      },

      editSuccessCallbackHandler: {
        type: Function,
        default: () => {}
      }
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('session', ['orderDetails']),
      ...mapGetters('orders', ['tableNumberDisplay']),
      ...mapGetters('content', ['content']),

      deliveryAddress() {
        const addr = this.orderDetails.deliveryAddress;
        if (!addr) return '';
        return formatAddressInline(addr, addr.countryCode);
      },

      locationAddress() {
        const addr = this.selectedLocation.address;
        if (!addr) return '';
        return formatAddressInline(addr, addr.countryCode);
      },

      orderDetailsContent() {
        const { orderType, fulfillmentType, pickupType } = this.orderDetails;
        const { metadata } = this.content.OrderModes;

        switch (true) {
          case orderType === 'table' || fulfillmentType === 'dine-in':
            return { name: metadata.menuTypeLabelDineIn, icon: 'fa-utensils', imageUrl: metadata.dineInImageUrl };

          case orderType === 'catering' && fulfillmentType === 'delivery':
            return { name: metadata.cateringDeliveryLabel, icon: 'fa-truck', imageUrl: metadata.cateringDeliveryImageUrl };

          case orderType === 'catering':
            return { name: metadata.cateringPickupLabel, icon: 'fa-hat-chef', imageUrl: metadata.cateringPickupImageUrl };

          case fulfillmentType === 'delivery':
            return { name: metadata.menuTypeLabelDelivery, icon: 'fa-car', imageUrl: metadata.deliveryImageUrl };

          case fulfillmentType === 'shipping':
            return { name: metadata.menuTypeLabelShipping, icon: 'fa-truck', imageUrl: metadata.shippingImageUrl };

          case fulfillmentType === 'room-service':
            return { name: metadata.menuTypeLabelRoomService, icon: 'fa-door-closed', imageUrl: metadata.roomServiceImageUrl };

          case pickupType === 'curbside':
            return { name: metadata.menuTypeLabelCurbsidePickup || 'Pickup', icon: 'fa-car-side', imageUrl: metadata.curbsidePickupImageUrl };

          case pickupType === 'drive-through':
            return { name: metadata.menuTypeLabelDriveThruPickup || 'Pickup', icon: 'fa-car', imageUrl: metadata.driveThruPickupImageUrl };

          default:
            return { name: metadata.menuTypeLabelPickup, icon: 'fa-shopping-bag', imageUrl: metadata.pickupImageUrl };
        }
      },

      displayRoomNumber() {
        /** Display the user's room number if tableNumberDisplay (ie. table number exists in url) */
        return this.orderDetails.fulfillmentType === 'room-service' && this.tableNumberDisplay;
      }
    },

    methods: {
      editOrderDetailsClickHandler() {
        this.$openModal('editOrderDetails', { editSuccessCallbackHandler: () => this.editSuccessCallbackHandler() });
      }
    }
  };
</script>
